<template>
  <div class="header-submenu__in-action">
      <div class="header-submenu__in-action-inner">
          <div class="header-submenu__items header-submenu__items--in-action">
            <a v-bind:href="item.url" class="header-submenu__item header-submenu__item-in-action" v-bind:class="[item.class, item.color ? `header-submenu__item-in-action--${item.color}` : '' ]" v-for="item in customItems ? customItems : defaultItems">
              <img :src="item.icon">
              <div class="header-submenu__item-in-action-content">
                <p class="header-submenu__link">{{item.name}}</p>
                <p class="header-submenu__p">{{item.description}}</p>
              </div>
            </a>
          </div>
      </div>
  </div>
</template>
<script>
  export default {
      props: [ 'customItems' ],

      data(){
          return {
              defaultItems: [
                  {
                      color: 'purple',
                      icon: '/dist/img/header/atinaction/sign-up.svg',
                      name: "Sign up for a free trial",
                      description: "Capture advantages of smart time tracking with a free trial",
                      url: "/free-online-trial"
                  },
                  {
                      color: 'green',
                      icon: '/dist/img/header/atinaction/demo-request.svg',
                      name: "Request a demo",
                      description: "Arrange a guided product tour with an actiTIME expert",
                      url: "/demo-request"
                  },
                  {
                      color: 'orange',
                      icon: '/dist/img/header/atinaction/contact-support.svg',
                      name: "Contact support",
                      description: "Reach out to be assisted by a product specialist",
                      url: "/contact-support"
                  }
              ],
          }
      }
  }
</script>

<style lang="scss">
@import '../../../../scss/variables.scss';
</style>


// WEBPACK FOOTER //
// app/Sites/AT/assets/js/vue/components/header/ATInAction.vue